import styled from "styled-components"

export const Header = styled.header`
  .header-container {
    background-color: ${props => props.theme.colors.darkBlue};
    padding: 12px 0;
  }

  .fixed-header-container {
    background-color: rgba(0, 65, 106, 0.8);
    padding: 12px 0;
    position: absolute;
    z-index: 999;
    width: 100%;
    transition: 0.3s ease;
    @media (max-width: 768px) {
      background-color: ${props => props.theme.colors.darkBlue};
      position: unset;
    }
  }
  nav {
    background-color: transparent !important;
    padding: 0;

    .navbar-toggler {
      border: 2px solid white;
      svg {
        color: white;
      }
    }

    .navbar-collapse {
      @media (max-width: 768px) {
        padding: 20px 0;
      }
      .navbar-nav {
        a {
          color: ${props => props.theme.colors.white};
          margin: 0 12px;
          color: ${props => props.theme.colors.white};
          text-decoration: none;
          font-weight: bold;
          letter-spacing: 1px;
          transition: 0.3s ease;
          &:hover {
            color: ${props => props.theme.colors.brightBlue};
          }
          @media (max-width: 768px) {
            margin: 8px 0;
          }
        }
        a.active {
          color: ${props => props.theme.colors.brightBlue};
        }
        a:last-child {
          margin-right: 0;
        }
      }
    }
  }
`

export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
`

export const Logo = styled.img`
  width: 125px;
`
